function tooltip() {
    "use strict";

    var $tooltips = $('.tooltip');

    for(var i = 0, l = $tooltips.length; i < l; ++i) {
        init($($tooltips.get(0)));
    }

    function init($tooltip) {
        var text = $tooltip.data('tooltip');

        var $dialog = $('<div class="tooltip__dialog">' + text + '</div>');
        $tooltip.append($dialog);

        $tooltip.on('mouseenter', onMouseEnter);
        $tooltip.on('mouseleave', onMouseLeave);
        $tooltip.on('click', onMouseEnter);
        $('body').on('click touchstart', onClickOutside);

        function onMouseEnter() {
            $dialog.addClass('tooltip__dialog--visible');
        }

        function onMouseLeave() {
            $dialog.removeClass('tooltip__dialog--visible');
        }

        function onClickOutside(e) {
            if(e.target !== $tooltip.get(0) && !isParent(e.target, $tooltip.get(0)) && $dialog.hasClass('tooltip__dialog--visible')) {
                $dialog.removeClass('tooltip__dialog--visible');
            }
        }

        function isParent(current, target) {
            if(current.parentElement == null) {
                return false;
            }

            if(current.parentElement === target) {
                return true;
            } else {
                return isParent(current.parentElement, target);
            }
        }
    }
}
jQuery(document).ready(function() {
    tooltip();
});

jQuery( document.body ).on( 'updated_checkout', function(){
    tooltip();
});